export default __webpack_public_path__ + "static/media/we-all-deserve-love-mobile.e895fc45.webp";